import Site_Minimal from './Site_Minimal'

export default {
    Site_Minimal,
}
